/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { customFieldFilterSchema } from './customFieldFilterSchema';

export const integrationFiltersSchema = z.object({
  get customFieldFilters() {
    return z.array(customFieldFilterSchema);
  },
  filterMode: z.enum(['BASIC', 'JQL']),
  includeWorkAfter: z.iso.date().nullish(),
  jql: z.string().nullish(),
  statusIds: z.array(z.string()).refine((items) => new Set(items).size === items.length, {
    message: 'Array entries must be unique',
  }),
  typeIds: z.array(z.string()).refine((items) => new Set(items).size === items.length, {
    message: 'Array entries must be unique',
  }),
});
